module.exports = __webpack_public_path__ + "static/media/img_Benchmarking105.431729db.png";